import useCustomDialogAlert from './useCustomDialogAlert'

export default useCustomDialogAlert
